import { network } from 'services/network';

export const getBaseLineDateOption = (projectId) => {
    return network.get(`api/bo/getBaseLineDateOption?projectId=${projectId}`).then((response) => {
        return response.data;
    });
};
